import { CellProps, Checkbox, Table } from "rsuite";

const { Cell } = Table;

export const EditableCheckBoxCell = ({
  rowData,
  dataKey,
  setReviewIds,
  ...props
}: CellProps<any> & { setReviewIds?: any }) => {
  return (
    <Cell align="center" {...props}>
      <Checkbox
        defaultChecked={rowData.checked}
        onChange={(value, checked) => {
          if (checked) {
            setReviewIds((prev: number[] | []) => [...prev, rowData.id]);
          } else {
            setReviewIds((prev: number[] | []) =>
              [...prev].filter((id) => id !== rowData.id)
            );
          }
        }}
      />
    </Cell>
  );
};
